const investmentFilterLang = {
	btn_more_filters: {
		tag: 'investment.filter.btn_more_filters',
		fr: 'Filtres',
		en: 'More filters',
	},
	dialog_filters_title: {
		tag: 'investment.filter.dialog_filters_title',
		fr: 'Filtres',
		en: 'Filters',
	},
	dialog_btn_apply: {
		tag: 'investment.filter.dialog_btn_apply',
		fr: 'Afficher',
		en: 'Apply',
	},
	not_call_yet: {
		tag: 'investment.filter.not_call_yet',
		fr: 'Pas encore appelé',
		en: 'Not call yet',
	},
	search_for_funds_private_credit: {
		tag: 'investment.filter.search_for_funds_private_credit',
		fr: 'Liste des fonds / mandats',
		en: 'Funds list',
	},
	search_for_funds_listed_assets: {
		tag: 'investment.filter.search_for_funds_listed_assets',
		fr: 'Fonds',
		en: 'Funds list',
	},
	search_for_funds_venture_capital: {
		tag: 'investment.filter.search_for_funds_venture_capital',
		fr: 'Participations',
		en: 'Positions',
	},
	search_for_asset_classes: {
		tag: 'investment.filter.search_for_asset_classes',
		fr: "Classes d'actifs",
		en: 'Assets classes',
	},
	search_for_placement_durations: {
		tag: 'investment.filter.search_for_placement_durations',
		fr: 'Durée de placement',
		en: 'Placement duration',
	},
	search_for_classification_amfs: {
		tag: 'investment.filter.search_for_classification_amfs',
		fr: 'Classification AMF',
		en: 'AMF Classification',
	},
	search_for_risk_levels: {
		tag: 'investment.filter.search_for_risk_levels',
		fr: 'Niveau de risque',
		en: 'Risk level',
	},
	search_for_thematiques: {
		tag: 'investment.filter.search_for_thematiques',
		fr: 'Thématiques',
		en: 'Thematics',
	},
	search_for_labels: {
		tag: 'investment.filter.search_for_labels',
		fr: 'Labels',
		en: 'Labels',
	},
	sub_portfolio: {
		tag: 'investment.filter.sub_portfolio',
		fr: 'Canton / Portefeuille',
		en: 'Sub portfolio',
	},
	quarter: {
		tag: 'investment.filter.quarter',
		fr: 'Période de reporting',
		en: 'Reporting period',
	},
	vintage: {
		tag: 'investment.filter.vintage',
		fr: 'Millésime',
		en: 'Vintage',
	},
	realization_status: {
		tag: 'investment.filter.realization_status',
		fr: 'Liquidé / Non liquidé',
		en: 'Realization status',
	},
	realization_status_option_realized: {
		tag: 'investment.filter.realization_status_option_realized',
		fr: 'Liquidé',
		en: 'Realized',
	},
	realization_status_option_unrealized: {
		tag: 'investment.filter.realization_status_option_unrealized',
		fr: 'Non liquidé',
		en: 'Unrealized',
	},
	asset_realization_status: {
		tag: 'investment.filter.asset_realization_status',
		fr: 'Actifs réalisés / Non réalisés',
		en: 'Asset realization status',
	},
	sfdr: {
		tag: 'investment.filter.sfdr',
		fr: 'SFDR',
		en: 'SFDR',
	},
	countries: {
		tag: 'investment.filter.countries',
		fr: 'Pays',
		en: 'Countries',
	},
	value_as_of_today: {
		tag: 'investment.filter.value_as_of_today',
		fr: 'À date',
		en: 'As of today',
	},
	investment_year: {
		tag: 'investment.filter.investment_year',
		fr: "Année d'investissement",
		en: 'Investment year',
	},
	domain: {
		tag: 'investment.filter.domain',
		fr: 'Domaine',
		en: 'Domain',
	},
	x_funds_private_credit: {
		tag: 'investment.filter.x_funds_private_credit',
		fr: '{{count}} fonds',
		en: '{{count}} funds',
		plurals: {
			zero: {
				fr: 'Aucune sélection',
				en: 'No selection',
			},
			one: {
				fr: '{{count}} fonds',
				en: '{{count}} fund',
			},
			other: {
				fr: '{{count}} fonds',
				en: '{{count}} funds',
			},
		},
	},
	x_funds_listed_assets: {
		tag: 'investment.filter.x_funds_listed_assets',
		fr: '{{count}} fonds',
		en: '{{count}} funds',
		plurals: {
			zero: {
				fr: 'Aucune sélection',
				en: 'No selection',
			},
			one: {
				fr: '{{count}} fonds',
				en: '{{count}} fund',
			},
			other: {
				fr: '{{count}} fonds',
				en: '{{count}} funds',
			},
		},
	},
	x_funds_venture_capital: {
		tag: 'investment.filter.x_funds_venture_capital',
		fr: '{{count}} participations',
		en: '{{count}} positions',
		plurals: {
			zero: {
				fr: 'Aucune participation',
				en: 'No position',
			},
			one: {
				fr: '{{count}} participation',
				en: '{{count}} position',
			},
			other: {
				fr: '{{count}} participations',
				en: '{{count}} positions',
			},
		},
	},
	x_asset_classes: {
		tag: 'investment.filter.x_asset_classes',
		fr: '{{count}} classes',
		en: '{{count}} classes',
		plurals: {
			zero: {
				fr: 'Aucune classe',
				en: 'No selection',
			},
			one: {
				fr: '{{count}} classe',
				en: '{{count}} class',
			},
			other: {
				fr: '{{count}} classes',
				en: '{{count}} classes',
			},
		},
	},
	x_placement_durations: {
		tag: 'investment.filter.x_placement_durations',
		fr: '{{count}} durées de placement',
		en: '{{count}} placement duration',
		plurals: {
			zero: {
				fr: 'Aucune durée de placement',
				en: 'No placement duration',
			},
			one: {
				fr: '{{count}} durée de placement',
				en: '{{count}} placement duration',
			},
			other: {
				fr: '{{count}} durées de placement',
				en: '{{count}} placement duration',
			},
		},
	},
	x_classification_amfs: {
		tag: 'investment.filter.x_classification_amfs',
		fr: '{{count}} classifications AMF',
		en: '{{count}} AMF classification',
		plurals: {
			zero: {
				fr: 'Aucune classification AMF',
				en: 'No AMF classification',
			},
			one: {
				fr: '{{count}} classification AMF',
				en: '{{count}} AMF classification',
			},
			other: {
				fr: '{{count}} classifications AMF',
				en: '{{count}} AMF classification',
			},
		},
	},
	x_risk_levels: {
		tag: 'investment.filter.x_risk_levels',
		fr: '{{count}} niveaux de risque',
		en: '{{count}} risk levels',
		plurals: {
			zero: {
				fr: 'Aucune niveau de risque',
				en: 'No risk level',
			},
			one: {
				fr: '{{count}} niveau de risque',
				en: '{{count}} risk level',
			},
			other: {
				fr: '{{count}} niveaux de risque',
				en: '{{count}} risk levels',
			},
		},
	},
	x_thematiques: {
		tag: 'investment.filter.x_thematiques',
		fr: '{{count}} thématiques',
		en: '{{count}} themes',
		plurals: {
			zero: {
				fr: 'Aucune thématique',
				en: 'No thématique',
			},
			one: {
				fr: '{{count}} thématique',
				en: '{{count}} theme',
			},
			other: {
				fr: '{{count}} thématiques',
				en: '{{count}} themes',
			},
		},
	},
	x_labels: {
		tag: 'investment.filter.x_labels',
		fr: '{{count}} labels',
		en: '{{count}} labels',
		plurals: {
			zero: {
				fr: 'Aucune certification',
				en: 'No label',
			},
			one: {
				fr: '{{count}} certification',
				en: '{{count}} label',
			},
			other: {
				fr: '{{count}} labels',
				en: '{{count}} labels',
			},
		},
	},
	x_funds_filtered: {
		tag: 'investment.filter.x_funds_filtered',
		fr: '{{count}} fonds valorisés et affichés sur {{outOf}}',
		en: '{{count}} funds valuated and displayed out of {{outOf}}',
		plurals: {
			zero: {
				fr: 'Aucun fonds valorisé ou affiché sur {{outOf}}',
				en: 'No fund valuated or displayed out of {{outOf}}',
			},
			one: {
				fr: '{{count}} fonds valorisé et affiché sur {{outOf}}',
				en: '{{count}} fund valuated and displayed out of {{outOf}}',
			},
			other: {
				fr: '{{count}} fonds valorisés et affichés sur {{outOf}}',
				en: '{{count}} funds valuated and displayed out of {{outOf}}',
			},
		},
	},
	view_details: {
		tag: 'investment.filter.view_details',
		fr: 'Accès aux détails : ',
		en: 'View details : ',
	},
};

export default investmentFilterLang;
